
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resource/[slug]",
      function () {
        return require("private-next-pages/resource/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resource/[slug]"])
      });
    }
  